/**
 * 自定义手风琴 js
 */

class CustomAccordion {
  constructor(target) {
    this.target = target; // dom 字符串
  }

  mount = () => {
    var buttons = document.querySelectorAll(
      `${this.target} .accordion-item__image`
    );

    function onAccordionItemClick($event) {
      buttons.forEach(function (button) {
        button.parentNode.classList.remove("active");
      });

      $event.currentTarget.parentNode.classList.add("active");
    }

    buttons.forEach(function (button) {
      button.addEventListener("click", onAccordionItemClick);
    });
  };
}
